<template>
  <div class="product-card">
    <div class="card-item">
      <template v-if="description">
        <p class="title">
          <img :src="icon" :style="iconsize" alt="">
          {{title}}
        </p>
        <p class="description">{{description}}</p>
      </template>
      <slot name="left"></slot>
    </div>
    <div class="card-item right">
      <slot name="right"></slot>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    icon: String,
    iconsize: String,
    title: String,
    description: String
  }
}
</script>

<style lang="less" scoped>
  .product-card{
    background-color: #fff;
    display: flex;
    column-gap: 2.188vw;
    height: 17.344vw;
    width: 100%;
    padding: 1.875vw 2.604vw;
    margin-bottom: 1.563vw;
    .card-item{
      padding: 1.667vw 2.5vw;
      border: 0.104vw solid #D6E4F4;
      width: 29.635vw;
      .title{
        font-size: 1.042vw;
        display: flex;
        column-gap: 0.625vw;
        align-items: center;
        margin-bottom: 1.042vw;
      }
      .description{
        font-size: 0.938vw;
        line-height: 1.458vw;
      }
    }
    .right{
      padding: 0;
      width: 35.885vw;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/productCard.vue